'use client';

import { useState } from 'react';

import Heading from '@/decodo/components/atoms/Heading';
import { Modal } from '@/decodo/components/atoms/Modal';

export type WelcomePopUpProps = {
  image?: React.ReactNode;
  title: string;
  description: React.ReactNode;
  buttons?: React.ReactNode;
};

export const WelcomePopUp = ({
  image,
  title,
  description,
  buttons,
}: WelcomePopUpProps) => {
  const [isVisible, setIsVisible] = useState(true);

  return (
    <Modal
      isOpen={isVisible}
      closeOnOutsideClick={false}
      onClose={() => setIsVisible(false)}
      backgroundClickable
      classNames={{
        modal: 'py-8 w-full md:w-fit',
        closeCross: 'w-6 h-6 text-gray-500',
        close: 'p-0 right-4 top-4',
        root: 'fixed left-0 bottom-0 z-50 flex items-end justify-start',
        overlay: 'backdrop-blur-none',
      }}
      lockScroll={false}
    >
      <div className='flex flex-col items-center gap-y-6'>
        <Heading level='h2' classNames={{ root: 'font-serif text-h3' }}>
          {title}
        </Heading>
        {image}
        <Heading
          level='h3'
          classNames={{
            root: 'text-gray-975 text-h4 flex flex-col items-center gap-y-3',
          }}
        >
          {description}
        </Heading>
      </div>
      {buttons}
    </Modal>
  );
};
